export enum PharmacyType {
    MED = 'rx_med',
    FOOD = 'rx_food',
    NOT_REQ = 'rx_not_req',
}
